import { render, staticRenderFns } from "./addressModifyList.vue?vue&type=template&id=18d0f706&scoped=true"
import script from "./addressModifyList.vue?vue&type=script&lang=js"
export * from "./addressModifyList.vue?vue&type=script&lang=js"
import style0 from "./addressModifyList.vue?vue&type=style&index=0&id=18d0f706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0f706",
  null
  
)

export default component.exports